"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const AppHeader_vue_1 = __importDefault(require("@/components/AppHeader.vue"));
const config_1 = require("./config");
exports.default = vue_1.default.extend({
    name: 'app',
    metaInfo: {
        title: 'Beasting Interval Timer',
    },
    data() {
        return {
            showHeader: true
        };
    },
    mounted() {
        this.$root.$on('showHeader', (show) => {
            this.showHeader = show;
        });
        if (process.env.VUE_ENV !== 'server') {
            Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "at", webpackMode: "lazy", webpackPreload: true */ './autotrack'))).then(() => {
                window.ga = window.ga || function () {
                    (window.ga.q = window.ga.q || []).push(arguments);
                };
                window.ga.l = +new Date;
                if (window.localStorage) {
                    const GA_LOCAL_STORAGE_KEY = "ga:clientId";
                    window.ga('create', config_1.GA_TRACKING_ID, {
                        'cookieDomain': config_1.GA_COOKIE_DOMAIN,
                        'storage': 'none',
                        'clientId': localStorage.getItem(GA_LOCAL_STORAGE_KEY)
                    });
                    window.ga(function (tracker) {
                        localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
                    });
                }
                else {
                    window.ga('create', config_1.GA_TRACKING_ID, config_1.GA_COOKIE_DOMAIN);
                }
                window.ga('require', 'cleanUrlTracker');
                window.ga('require', 'outboundLinkTracker');
                window.ga('require', 'urlChangeTracker');
                window.ga('require', 'mediaQueryTracker', {
                    definitions: [
                        {
                            name: 'Breakpoint',
                            dimensionIndex: 1,
                            items: [
                                { name: 'xs', media: 'all' },
                                { name: 'sm', media: '(min-width: 576px)' },
                                { name: 'md', media: '(min-width: 768px)' },
                                { name: 'lg', media: '(min-width: 992px)' },
                                { name: 'xl', media: '(min-width: 1200px)' }
                            ]
                        },
                        {
                            name: 'Pixel Density',
                            dimensionIndex: 2,
                            items: [
                                { name: '1x', media: 'all' },
                                { name: '1.5x', media: '(min-resolution: 144dpi)' },
                                { name: '2x', media: '(min-resolution: 192dpi)' },
                                { name: '3x', media: '(min-resolution: 288dpi)' }
                            ]
                        },
                        {
                            name: 'Device Orientation',
                            dimensionIndex: 3,
                            items: [
                                { name: 'landscape', media: '(orientation: landscape)' },
                                { name: 'portrait', media: '(orientation: portrait)' }
                            ]
                        }
                    ]
                });
                window.ga('send', 'pageview');
            });
        }
    },
    components: {
        AppHeader: AppHeader_vue_1.default
    }
});
